import { createFileRoute, redirect } from '@tanstack/react-router';

/** /catalog-v2 is a container — redirect to Runs so the URL always names the open screen. */
export const Route = createFileRoute('/_authenticated/_tenant/catalog-v2/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw redirect({ to: '/catalog-v2/runs' });
  },
});
